// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-index-template-js": () => import("/github/workspace/docs/src/templates/IndexTemplate.js" /* webpackChunkName: "component---src-templates-index-template-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/github/workspace/docs/.cache/data.json")

